/* =========================================================
   Complete o look (carrinho lateral e pop-up de produto adicionado)
   1) Botões com data-mm-add adicionam a variante com um toque.
   2) Quando o carrinho muda, a lista do carrinho lateral é refeita,
      porque o tema só atualiza os produtos e o rodapé da gaveta.
   3) No pop-up, "Escolher" fecha o pop-up antes de abrir as opções.
   ========================================================= */

(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function secaoDoCarrinho() {
    var drawer = document.querySelector('cart-drawer');
    var secao = drawer && drawer.closest('.shopify-section');
    return secao ? secao.id.replace('shopify-section-', '') : null;
  }

  function mostrarErro(item, texto) {
    var erro = item.querySelector('.mm-look__erro');
    if (!erro) {
      erro = document.createElement('p');
      erro.className = 'mm-look__erro';
      item.querySelector('.mm-look__info').appendChild(erro);
    }
    erro.textContent = texto;
  }

  async function adicionar(botao) {
    var item = botao.closest('.mm-look__item');
    var botoes = item.querySelectorAll('[data-mm-add]');
    var secao = secaoDoCarrinho();
    var corpo = { items: [{ id: Number(botao.getAttribute('data-mm-add')), quantity: 1 }] };

    if (secao) {
      corpo.sections = [secao];
      corpo.sections_url = window.location.pathname;
    }

    botoes.forEach(function (b) { b.disabled = true; });
    botao.setAttribute('aria-busy', 'true');

    try {
      var resposta = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corpo),
      });
      var dados = await resposta.json();
      if (!resposta.ok) throw new Error(dados.description || dados.message || 'Não foi possível adicionar.');

      var carrinho = await (await fetch(root + 'cart.js')).json();
      carrinho.sections = dados.sections || {};

      botao.removeAttribute('aria-busy');
      botao.classList.add('is-added');
      botao.textContent = botao.classList.contains('mm-look__chip') ? botao.textContent.trim() + ' ✓' : 'Adicionado ✓';

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: carrinho } })
      );
    } catch (erro) {
      botao.removeAttribute('aria-busy');
      botoes.forEach(function (b) { b.disabled = false; });
      mostrarErro(item, erro.message);
    }
  }

  document.addEventListener('click', function (event) {
    var botao = event.target.closest('[data-mm-add]');
    if (botao) {
      event.preventDefault();
      if (!botao.disabled) adicionar(botao);
      return;
    }

    var escolher = event.target.closest('.mm-look--popup [data-mm-escolher]');
    if (escolher) {
      var popup = escolher.closest('quick-buy-drawer');
      setTimeout(function () {
        if (popup && typeof popup.hide === 'function') popup.hide();
      }, 60);
    }
  });

  document.addEventListener('cart:change', async function (event) {
    var carrinho = event.detail && event.detail.cart;
    var secao = secaoDoCarrinho();
    if (!carrinho || !carrinho.item_count || !secao) return;

    var html = carrinho.sections && carrinho.sections[secao];
    if (!html) {
      try {
        html = await (await fetch(root + '?section_id=' + secao)).text();
      } catch (e) {
        return;
      }
    }

    var novo = new DOMParser().parseFromString(html, 'text/html').querySelector('.mm-look-slot');
    var atual = document.querySelector('cart-drawer .mm-look-slot');
    if (novo && atual) atual.innerHTML = novo.innerHTML;
  });
})();
